import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslocoService } from '@ngneat/transloco';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'formly-ion-section',
  standalone: true,
  templateUrl: './custom-ion-form-section.component.html',
  styleUrls: ['./custom-ion-form-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, IonicModule, ReactiveFormsModule],
})
export class CustomIonFormSectionComponent extends FieldWrapper {
  constructor(protected translocoService: TranslocoService) {
    super();
  }
}